interface CompleteDriverGroupDeletionParams {
  deletedMessage: string;
  closeDeleteDialog: () => void;
  forgetGroup: () => void;
  showToast: (message: string) => void;
}

export function completeDriverGroupDeletion({
  deletedMessage,
  closeDeleteDialog,
  forgetGroup,
  showToast,
}: CompleteDriverGroupDeletionParams): void {
  closeDeleteDialog();
  forgetGroup();
  showToast(deletedMessage);
}
